module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrightx"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("First published in 2021 by Birlinn Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("West Newington House")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 Newington Road")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Edinburgh")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("EH9 1QS")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Text © Peter Evans, 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Photographs © Peter Evans unless otherwise acknowledged")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN: 978 1 78027 590 1"), _c('br'), _vm._v("eBook ISBN 978 1 78885 209 8")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The moral right of Peter Evans to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightb"
  }, [_vm._v("Printed in China through World Print Ltd")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0